module.exports = __webpack_public_path__ + "img/zsbg.6f6a62cb.png";